export enum CustomFieldCategoryEnum {
  USER = "user",
}
